import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// --- PrimeNG ---
import { InputNumberModule } from 'primeng/inputnumber';

// --- Component ---
import { CounterComponent } from './counter.component';

@NgModule({
	declarations: [CounterComponent],
	imports: [
		CommonModule,
		FormsModule,

		// --- PrimeNG ---
		InputNumberModule,
	],
	exports: [CounterComponent],
})
export class CounterModule {}
